export const TickIcon = ({ ...props }) => {
  return (
    <svg height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="m0 0h16v16h-16z" fill="none" />
      <path d="m0 9.014 1.414-1.414 3.59 3.589 9.589-9.589 1.414 1.414-11.004 11.003z" fill="currentColor" />
    </svg>
  );
};
